const createScenario = {
  title: 'Construir un escenario',

  form: {
    header: {
      title: 'Hola {{firstName}}:',
    },
    fields: {
      sitePlaceHolder: '¿Cual es el nombre de su operación?',
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: '¿Qué escenario le gustaría ejecutar con Moovex?',
        instructions: 'Por favor, marca el campo que más describe tu zona de actividad.',
      },
    },

    button: 'QUIERO Construir un escenario',
  },
};

export default createScenario;
